import { render } from "./indextwopopular.vue?vue&type=template&id=9f3528e6"
import script from "./indextwopopular.vue?vue&type=script&lang=js"
export * from "./indextwopopular.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__